import { useEffect } from "react";

const DEFAULT_CHROME = "#7c3aed";
const CLIENT_PAGE_BG = "#f4f5f8";
const ADMIN_PAGE_BG = "#f4f5f8";

function parseHex(hex) {
  const m = String(hex || "").match(/^#([0-9A-Fa-f]{6})$/);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

/** Относительная яркость 0…1 — для выбора светлого/тёмного статус-бара iOS. */
export function isDarkHexColor(hex) {
  const rgb = parseHex(hex);
  if (!rgb) return true;
  const { r, g, b } = rgb;
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum < 0.55;
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Цвет зоны статус-бара / «чёлки».
 * @param {string} color — hex
 * @param {object} options
 * @param {boolean} [options.isDark] — тёмный статус-бар (белые иконки)
 * @param {boolean} [options.immersive] — главная с hero: без отдельной полоски, контент под чёлкой
 */
export function applyPwaChromeColor(color, { isDark, immersive = false } = {}) {
  if (typeof document === "undefined") return;

  const bg = parseHex(color) ? color : DEFAULT_CHROME;
  const dark = isDark ?? isDarkHexColor(bg);

  setMeta("theme-color", bg);
  setMeta(
    "apple-mobile-web-app-status-bar-style",
    dark || immersive ? "black-translucent" : "default",
  );

  const root = document.documentElement;
  root.style.setProperty("--pwa-chrome-bg", bg);
  root.classList.add("pwa-chrome-themed");
  root.classList.toggle("pwa-chrome-dark", dark);
  root.classList.toggle("pwa-chrome-light", !dark);
  root.classList.toggle("pwa-chrome-immersive", immersive);
}

export function resetPwaChromeColor() {
  if (typeof document === "undefined") return;
  applyPwaChromeColor(DEFAULT_CHROME, { isDark: true, immersive: false });
}

export { CLIENT_PAGE_BG, ADMIN_PAGE_BG };

/** Синхронизирует «чёлку» при смене страницы / брендинга. */
export function usePwaChrome(color, { enabled = true, isDark, immersive = false } = {}) {
  useEffect(() => {
    if (!enabled || !color) return undefined;
    applyPwaChromeColor(color, { isDark, immersive });
    return undefined;
  }, [color, enabled, isDark, immersive]);
}
